import { api } from '../../DefaultService';
import { IGvdasaCreateProps, IGvdasaProps, IGvdasaUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/gvdasa';

export const createGvdasaIntegrationAsync = async (
  data: IGvdasaCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllGvdasaIntegrationsAsync = async (): Promise<
  IGvdasaProps[]
> => {
  return await api
    .get<IGvdasaProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getGvdasaIntegrationByIdAsync = async (
  id: number,
): Promise<IGvdasaProps> => {
  return await api
    .get<IGvdasaProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateGvdasaIntegrationAsync = async ({
  id,
  data,
}: IGvdasaUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteGvdasaIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
